import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG Modules
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';

// Components
import { BusquedaClienteComponent } from './busqueda-cliente.component';
import { BusquedaProveedorComponent } from '../busqueda-proveedor/busqueda-proveedor.component';

@NgModule({
  declarations: [
    BusquedaClienteComponent,
    BusquedaProveedorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    TableModule,
    InputTextModule
  ],
  exports: [
    BusquedaClienteComponent,
    BusquedaProveedorComponent
  ]
})
export class BusquedaClienteModule { }
